import { getEnvironment } from '@sail/utils';
import CURRENT_PINNED_VERSION from '../schema/version';
export default function getSchemaVersion() {
    return getEnvironment() === 'test' ? 'faux-version' : CURRENT_PINNED_VERSION;
}

//# sourceMappingURL=getSchemaVersion.js.map